import { Popover, Button, Card, Tag, Typography, Space, Row, Col, Divider } from "antd"
import { useState, useContext } from "react"
import { ClockCircleOutlined, EyeOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { ModalHistoryConcept } from "../../implementer/submissions/new/human-resources/resources-list/modal/modal-history-concept"
import { ImplementerSubmissionContext } from "../../../contexts/implementer/submissions/new/context"
import { AdminSubmissionContext } from "../../../contexts/admin/submissions/show"
import React from "react"
import { submissionStatusOptions } from "../../../helpers/selectOptions/shared/submission-status"

PositionHistory.propTypes = {
  id: PropTypes.string,
  small: PropTypes.bool
}
export function PositionHistory({ id, small = false, isConsultant = false, isAdminPage = false }) {

  const { Text } = Typography;
  const [modalOpen, setModalOpen] = useState(false)
  const [data, setData] = useState(null)
  const [historyData, setHistoryData] = useState([])
  const [type, setType] = useState("")
  const [popoverOpen, setPopoverOpen] = useState(false)
  const context = useContext(ImplementerSubmissionContext)
  const adminContext = useContext(AdminSubmissionContext)

  const [counts, setCounts] = useState({
    altas: 0,
    cambios: 0,
    bajas: 0,
    sustitucion: 0,
    rechazados: 0,
  })

  const colorsStatus = {
    comentarios: "#FAAD14",
    rechazado: "#FF4D4F",
    aprobado: "#52C41A",                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    enviado: "#555555",
    baja: "#ABA7A7",
  }

  const getHistory = async () => {
    if (isConsultant) {
      setHistoryData([])
    } else {
      const dataHistory = await context?.getHistoryConcept({ variables: { conceptId: id }})
      
      const result = dataHistory?.data?.getHistoryConcept;
      
      setCounts({
        altas: result?.counts?.altas ?? 0,
        cambios: result?.counts?.cambios ?? 0,
        bajas: result?.counts?.bajas ?? 0,
        sustitucion: result?.counts?.sustitucion ?? 0,
        rechazados: result?.counts?.rechazados ?? 0,
      })

      const validHistory = dataHistory?.data?.getHistoryConcept?.history.filter(
        item => item?.rfc?.trim()
      )
      
      if (validHistory.length > 0) {
        const formatDataHistory = validHistory.map((item) => ({
          date: item.requestDate?.split("T")[0],
          status: item.status,
          currentValue: `${item.name} ${item.lastName} ${item.secondLastName}`,
          previousValue: item.resigningName ? item.resigningName : "N/A",
          currentId: item.id,
          statusColor: colorsStatus[item.status],
          type: item.resigningName ? "change" : "add",
          item2: {
            formID: item.id
          },
          item1: item.resigningName ? {
            formName: item.resigningName
          } : null,
          title: item.resigningName ? "Cambio de persona" : "Alta de Persona"
        }))

        setHistoryData(formatDataHistory)
      }
    }
  }


  const formatDataAdmin = (data, rfcQuery, colorsStatus) => {
  if (!Array.isArray(data)) return [];
  const sorted = [...data].sort(
    (a, b) => new Date(b.requestDate) - new Date(a.requestDate)
  );
  return sorted.map((item, index) => {

    const submissionStatusLabel = submissionStatusOptions.find(
      status => status.value === item.submissionStatus
    )?.label || "Sin estatus"
    
    const isLatest = index === 0;

   
    const startDate = item.effectiveDate
      ? new Date(item.effectiveDate)
      : null;

    let endDate = null;

    if (item.resigning_rfc && item.resigning_rfc === rfcQuery) {
      endDate = item.terminationDate
        ? new Date(item.terminationDate)
        : null;
    }

    const format = (date) => {
      if (!date) return "";
      const d = date.getDate().toString().padStart(2, "0");
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    };

    const fechas = startDate
      ? `${format(startDate)} - ${endDate ? format(endDate) : ""}`
      : "";

    return {
      proyecto: `${item.project} - ${submissionStatusLabel}`,
      puesto: item.position,
      concept: item.conceptId,
      fechas,
      type: item.resigningName ? "change" : "add",
      item2: {
            formID: item.id
          },
          item1: item.resigningName ? {
            formName: item.resigningName
          } : null,
    };
  });
};

  const getHistoryRRHH = async () => {
     const dataHistory = await adminContext?.getHistoryRRHH({ variables: { rfc: id } })
     const result = formatDataAdmin(dataHistory?.data?.getHistoryRRHH, id , colorsStatus);
    setHistoryData(result)
  }

  const getInfoModal = async (type, item) => {
    try {
      let formatDataHistory = { ...item }
      const { data } = await (context || adminContext )?.getHistoryByPerson({
        variables: {
          conceptId: isAdminPage ? item.concept : id, 
          rfc: "",
          formf50Id: formatDataHistory.item2.formID, resigningName: formatDataHistory?.item1 ? formatDataHistory.item1.formName : ""
        }
      })

      const info = data.getHistoryByPerson.filter(
        item => item?.rfc?.trim()
      )

      if (info.length > 1) {

        formatDataHistory.item2 = {
          date: info[0].effectiveDate?.split("T")[0],
          name: `${info[0].name} ${info[0].lastName} ${info[0].secondLastName}`,
          rfc: info[0].rfc,
          contratacion: info[0].contractType,
          phone: info[0].phone,
          email: info[0].email,
          prestaciones: info[0].benefits,
          documents: info[0].documents,
          relationship: info[0].relationship,
          relationshipDetail: info[0].relationshipDetail,
          position_administration: info[0].position_administration,
          contractType_administration: info[0].contractType_administration,
          hours_administration: info[0].hours_administration,
          convocatoria: info[0].publicCall,
          gobierno: info[0].publicAdministration,
          servicios: info[0].publicAdministration,
          comentarios: info[0].adminComment
        }

        formatDataHistory.item1 = {
          date: info[0].terminationDate?.split("T")[0],
          name: `${info[1].name} ${info[1].lastName} ${info[1].secondLastName}`,
          rfc: info[1].rfc,
          contratacion: info[1].contractType,
          phone: info[1].phone,
          email: info[1].email,
          prestaciones: info[1].benefits,
          documents: info[1].documents,
          relationship: info[0].relationship,
          relationshipDetail: info[0].relationshipDetail,
          position_administration: info[0].position_administration,
          contractType_administration: info[0].contractType_administration,
          hours_administration: info[0].hours_administration,
          convocatoria: info[1].publicCall,
          gobierno: info[1].publicAdministration,
          servicios: info[1].publicAdministration,
          comentarios: info[0].adminComment
        }

      } else {
        formatDataHistory.item2 = {
          date: info[0].effectiveDate?.split("T")[0],
          name: `${info[0].name} ${info[0].lastName} ${info[0].secondLastName}`,
          rfc: info[0].rfc,
          contratacion: info[0].contractType,
          phone: info[0].phone,
          email: info[0].email,
          prestaciones: info[0].benefits,
          relationship: info[0].relationship,
          relationshipDetail: info[0].relationshipDetail,
          position_administration: info[0].position_administration,
          contractType_administration: info[0].contractType_administration,
          hours_administration: info[0].hours_administration,
          documents: info[0].documents,
          convocatoria: info[0].publicCall,
          gobierno: info[0].publicAdministration,
          servicios: info[0].publicAdministration,
          comentarios: info[0].adminComment
        }
      }
      setType(type)
      setModalOpen(true)
      setData(formatDataHistory)
    } catch (e) {
      console.error(e)
    }

  }

  const countsDashboard = (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 12,
        padding: "12px 0",
        marginBottom: 12,
        backgroundColor: "#fff",
      }}
    >
      {[
        { label: "Altas", value: counts.altas, color: "#52C41A" },
        { label: "Cambios", value: counts.cambios, color: "#555555" },
        { label: "Bajas", value: counts.bajas, color: "#8c8c8c" },
        { label: "Sustitución", value: counts.sustitucion, color: "#13a8a8" },
        { label: "Rechazados", value: counts.rechazados, color: "#ff4d4f" },
      ].map((item) => (
        <div
          key={item.label}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "8px 18px",
            borderRadius: 999,
            border: "1.5px solid #d9d9d9",
            backgroundColor: "#fff",
            whiteSpace: "nowrap",
          }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: item.color,
              flexShrink: 0,
            }}
          />
          <Text strong style={{ color: "#333", fontSize: 15 }}>
            {item.label}
          </Text>
          <Text strong style={{ color: "#333", fontSize: 15 }}>
            {item.value}
          </Text>
        </div>
      ))}
    </div>
  )

  const content = (
    <div style={{ width: "400px", height: "400px", overflowX: "hidden", overflowY: "scroll" }}>
      {countsDashboard}
      <p>Cambios</p>
      {
        historyData.map((item) => (
          <>
            <Card
              size="small"
              style={{
                borderRadius: 12,
                backgroundColor: "#f5f5f5",
                marginRight: "15px"
              }}
              bodyStyle={{ padding: 16 }}
            >
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Space size={8}>
                  <Text strong style={{ fontSize: 16 }}>
                    {item.title}
                  </Text>
                  <Text type="secondary">{item.date}</Text>
                </Space>

                <Tag color={item.statusColor} style={{ borderRadius: 20 }} variant="solid">
                {item.status?.charAt(0).toUpperCase() + item.status?.slice(1)}
                </Tag>
              </Space>

              <div style={{ marginTop: 16 }}>
                <Row>
                  <Col span={21}>
                    <Space direction="vertical" style={{ width: "100%" }} size={12}>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text type="secondary">Persona anterior: <Text>{item.previousValue}</Text> </Text>
                      </Space>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text type="secondary">Persona actual:  <Text>{item.currentValue}</Text> </Text>
                      </Space>

                    </Space>
                  </Col>
                  <Col span={3} style={{ alignContent: "center" }}>
                    <Space>
                      <Button
                        shape="circle"
                        size="large"
                        icon={<EyeOutlined />}
                        onClick={() => { getInfoModal(item.type, item) }}
                      />
                    </Space>
                  </Col>
                </Row>

              </div>
            </Card>
            <br />
          </>
        ))
      }
    </div>
  )

  const contentAdminPage = (
    <div style={{ width: "400px", height: "400px", overflowX: "hidden", overflowY: "scroll" }}>
      <p>Cambios RRHH</p>
      {
        historyData.map((item) => (
          <>
            <Card
              size="small"
              style={{
                borderRadius: 12,
                backgroundColor: "#f5f5f5",
                marginRight: "15px"
              }}
              bodyStyle={{ padding: 16 }}
            >
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Space size={8}>
                  <Text strong style={{ fontSize: 16 }}>
                    {item.proyecto}
                  </Text>
                </Space>
{/* 
                <Tag color={item.statusColor} style={{ borderRadius: 20 }} variant="solid">
                {item.status?.charAt(0).toUpperCase() + item.status?.slice(1)}
                </Tag> */}
              </Space>

              <div style={{ marginTop: 16 }}>
                <Row>
                  <Col span={21}>
                    <Space direction="vertical" style={{ width: "100%" }} size={12}>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text type="secondary">{item.puesto} <Text>{item.fechas}</Text> </Text>

                      </Space>

                    </Space>
                  </Col>
                  <Col span={3} style={{ alignContent: "center" }}>
                    <Space>
                      <Button
                        shape="circle"
                        size="large"
                        icon={<EyeOutlined />}
                        onClick={() => { getInfoModal(item.type, item) }}
                      />
                    </Space>
                  </Col>
                </Row>

              </div>
            </Card>
            <br />
          </>
        ))
      }
    </div>
  )


  let tooltipButton = (
    <Button
      style={isConsultant ? { marginLeft: "3px", float: 'right' } : { float: 'right' }}
      size="middle"
      shape="circle"
      icon={<ClockCircleOutlined />}
      onClick={() => { getHistory() }}
    />
  )

  if (isAdminPage){
    tooltipButton =(
    <Button
      style={isConsultant ? { marginLeft: "3px", float: 'right' } : { float: 'right' }}
      size="middle"
      shape="circle"
      icon={<ClockCircleOutlined />}
      onClick={() => { getHistoryRRHH() }}
    />)}
  

  if (small) {
    tooltipButton = (
      <Button
        style={isConsultant ? { marginLeft: "3px", float: 'right' } : { float: 'right' }}
        size="small"
        shape="circle"
        icon={<ClockCircleOutlined />}
        onClick={() => { }}
      />
    )
  }
  
  return (
    <>
      <Popover
        placement="right"
        content={isAdminPage ? contentAdminPage : content}
        title={
          isAdminPage
            ? "Historial de la actividad del RRHH"
            : "Lista de Cambios"
        }
        trigger="click"
        open={popoverOpen}
        onOpenChange={(open) => setPopoverOpen(open)}
      >
        {tooltipButton}
      </Popover>
  
      <ModalHistoryConcept
        open={modalOpen}
        dataItem={data}
        type={type}
        onCancel={() => {
          setModalOpen(false);
          setData(null);
          setType("");
  
          setTimeout(() => {
            setPopoverOpen(true);
          }, 0);
        }}
      />
    </>
  )
}